<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="handleLogin">
                  <b-button @click="changeLocale(enLang.language)" variant="outline-light" class="mb-1" size="sm">
                    <i class="flag-icon flag-icon-gb flag-icon-squared" size="sm"></i>
                  </b-button>
                  <b-button @click="changeLocale(czLang.language)" variant="outline-light" class="mb-1" size="sm">
                    <i class="flag-icon flag-icon-cz flag-icon-squared" size="sm"></i>
                  </b-button>
                  <h1>{{ $t('login.loginTxt') }}</h1>
                  <p class="text-muted">{{ $t('login.loginDesc') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      :placeholder="$t('login.holderUsername')"
                      autocomplete="username"
                      v-model="username"
                      name="username"
                      :class="{ 'is-invalid': submitted && !username }"
                    />
                    <div
                      v-show="submitted && !username"
                      class="invalid-feedback"
                    >{{ $t('login.userLogin') }}</div>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      :placeholder="$t('login.holderPassword')"
                      autocomplete="current-password"
                      v-model="password"
                      name="password"
                      :class="{ 'is-invalid': submitted && !password }"
                    />
                    <div
                      v-show="submitted && !password"
                      class="invalid-feedback"
                    >{{ $t('login.passLogin') }}</div>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="px-4"
                        :disabled="loading"
                      >{{ $t('login.subLogin') }}</b-button>
                    </b-col>
                  </b-row>
                  <div v-if="error" class="alert alert-danger">{{error}}</div>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>VizWeb Viewer</h2>
                  <!--<p>Viewer for visualization schemes of Vizweb applications</p>-->
                  <p>{{ $t('login.viewerDesc') }}</p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { router } from "@/router";
import { authService } from "@/_services";
import { errorHandler } from "@/_helpers";
import { i18n } from "@/_plugins/i18n";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      returnUrl: "",
      error: "",
      enLang: { language: "en", title: "English" },
      czLang: { language: "cs", title: "Česky" }
    };
  },
  created() {
    // reset login status
    authService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    },
    handleLogin() {
      this.submitted = true;
      const { username, password } = this;

      // stop here if form is invalid
      if (!(username && password)) {
        return;
      }

      this.loading = true;
      authService
        .login(username, password)
        .then(response => {
          const user = response.data;
          user.authdata = window.btoa(username + ":" + password);
          localStorage.setItem("viewer-user", JSON.stringify(user));

          router.push(this.returnUrl);
        })
        .catch(error => {
          this.error = errorHandler(error);
          this.loading = false;
        });
    }
  }
};
</script>